var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.25V7.75C16 7.5 15.8 7.25 15.6 7.25H8.6V6H10.4C10.825 6 11.2 5.5625 11.2 5V1C11.2 0.46875 10.825 0 10.4 0H5.6C5.15 0 4.8 0.46875 4.8 1V5C4.8 5.5625 5.15 6 5.6 6H7.4V7.25H0.4C0.175 7.25 0 7.5 0 7.75V8.25C0 8.53125 0.175 8.75 0.4 8.75H3V10H1.6C1.15 10 0.8 10.4688 0.8 11V15C0.8 15.5625 1.15 16 1.6 16H5.6C6.025 16 6.4 15.5625 6.4 15V11C6.4 10.4688 6.025 10 5.6 10H4.2V8.75H11.8V10H10.4C9.95 10 9.6 10.4688 9.6 11V15C9.6 15.5625 9.95 16 10.4 16H14.4C14.825 16 15.2 15.5625 15.2 15V11C15.2 10.4688 14.825 10 14.4 10H13V8.75H15.6C15.8 8.75 16 8.53125 16 8.25ZM6.4 4V2H9.6V4H6.4ZM4.8 14H2.4V12H4.8V14ZM13.6 14H11.2V12H13.6V14Z",
    fill: "#2940E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsActive);
export default __webpack_public_path__ + "static/media/integrations-active.ac4cdafc1d870f7d4ca5281b49016c55.svg";
export { ForwardRef as ReactComponent };